// Generated by purs version 0.15.15
import * as $foreign from "./foreign.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Effect_Ref from "../Effect.Ref/index.js";
import * as Effect_Uncurried from "../Effect.Uncurried/index.js";
import * as Foreign_Object from "../Foreign.Object/index.js";
import * as Specular_Dom_Browser from "../Specular.Dom.Browser/index.js";
import * as Specular_Dom_Builder from "../Specular.Dom.Builder/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
import * as Specular_Internal_Effect from "../Specular.Internal.Effect/index.js";
import * as Specular_Internal_Profiling from "../Specular.Internal.Profiling/index.js";
import * as Specular_Profiling from "../Specular.Profiling/index.js";
var measure = /* #__PURE__ */ Specular_Profiling.measure(Effect_Class.monadEffectEffect);
var mempty = /* #__PURE__ */ Data_Monoid.mempty(Data_Monoid.monoidArray);
var bind1 = /* #__PURE__ */ Control_Bind.bind(Specular_Dom_Builder.bindBuilder);
var subscribeDyn_ = /* #__PURE__ */ Specular_FRP_Base.subscribeDyn_(/* #__PURE__ */ Specular_FRP_Base.monadFRP(Specular_Dom_Builder.monadEffectBuilder)(Specular_Dom_Builder.monadCleanupBuilder));
var readDynamic = /* #__PURE__ */ Specular_FRP_Base.readDynamic(Effect_Class.monadEffectEffect);
var notEq = /* #__PURE__ */ Data_Eq.notEq(/* #__PURE__ */ Data_Maybe.eqMaybe(Data_Eq.eqString));
var mapFlipped = /* #__PURE__ */ Data_Functor.mapFlipped(Specular_FRP_Base.functorDynamic);
var mempty1 = /* #__PURE__ */ Data_Monoid.mempty(/* #__PURE__ */ Foreign_Object.monoidObject(Data_Semigroup.semigroupString));
var Prop = function (x) {
    return x;
};
var unsafeEventTarget = function (e) {
    return e.target;
};
var withTargetChecked = function (cb) {
    return function (event) {
        return function __do() {
            var value = Specular_Dom_Browser.getCheckboxChecked(unsafeEventTarget(event))();
            return cb(value)();
        };
    };
};
var withTargetValue = function (cb) {
    return function (event) {
        return function __do() {
            var value = Specular_Dom_Browser.getTextInputValue(unsafeEventTarget(event))();
            return cb(value)();
        };
    };
};
var text = function (str) {
    return Specular_Dom_Builder["mkBuilder$prime"](function (env) {
        var node = Specular_Dom_Browser.createTextNode(str)();
        return Specular_Dom_Browser.appendChild(node)(env.parent)();
    });
};
var stopPropagation = /* #__PURE__ */ Effect_Uncurried.runEffectFn1($foreign["_stopPropagation"]);
var semigroupProp = {
    append: function (v) {
        return function (v1) {
            return function (node, cleanups) {
                v(node, cleanups);
                return v1(node, cleanups);
            };
        };
    }
};
var append1 = /* #__PURE__ */ Data_Semigroup.append(semigroupProp);
var rawHtml = function (html) {
    return Specular_Dom_Builder.mkBuilder(function (env) {
        return Specular_Dom_Browser.appendRawHtml(html)(env.parent);
    });
};
var preventDefault = Specular_Dom_Browser.preventDefault;
var on = function (eventType) {
    return function (cb) {
        return function (node, _cleanups) {
            Specular_Dom_Browser.addEventListener(eventType)(function (e) {
                return measure("event: " + eventType)(cb(e));
            })(node)();
            return Data_Unit.unit;
        };
    };
};
var onClick = function (cb) {
    return on("click")(cb);
};
var onClick_ = function (cb) {
    return onClick(function (v) {
        return cb;
    });
};
var monoidProp = {
    mempty: function (v, v1) {
        return Data_Unit.unit;
    },
    Semigroup0: function () {
        return semigroupProp;
    }
};
var mempty2 = /* #__PURE__ */ Data_Monoid.mempty(monoidProp);
var mempty3 = /* #__PURE__ */ Data_Monoid.mempty(/* #__PURE__ */ Data_Monoid.monoidFn(monoidProp));
var initElement = function (env, node, props, body) {
    var mark = Specular_Internal_Profiling.begin("el");
    var result = Specular_Dom_Builder["runBuilder$prime"]({
        cleanup: env.cleanup,
        userEnv: env.userEnv,
        parent: node
    }, body);
    Effect.foreachE(props)(function (v) {
        return function () {
            return v(node, env.cleanup);
        };
    })();
    Specular_Dom_Browser.appendChild(node)(env.parent)();
    Specular_Internal_Profiling.end(mark);
    return result;
};
var elNS$prime = function (ns) {
    return function (tagName) {
        return function (props) {
            return function (body) {
                return Specular_Dom_Builder["mkBuilder$prime"](function (env) {
                    var node = Specular_Dom_Browser.createElementNS(ns)(tagName)();
                    var result = initElement(env, node, props, body);
                    return new Data_Tuple.Tuple(node, result);
                });
            };
        };
    };
};
var el$prime = function (tagName) {
    return function (props) {
        return function (body) {
            return Specular_Dom_Builder["mkBuilder$prime"](function (env) {
                var node = Specular_Dom_Browser.createElement(tagName)();
                var result = initElement(env, node, props, body);
                return new Data_Tuple.Tuple(node, result);
            });
        };
    };
};
var el = function (tagName) {
    return function (props) {
        return function (body) {
            return Specular_Dom_Builder["mkBuilder$prime"](function (env) {
                var node = Specular_Dom_Browser.createElement(tagName)();
                return initElement(env, node, props, body);
            });
        };
    };
};
var el_ = function (tagName) {
    return el(tagName)(mempty);
};
var dynText = function (strD) {
    return bind1(Specular_Dom_Builder["mkBuilder$prime"](function (env) {
        var node = Specular_Dom_Browser.createTextNode("")();
        Specular_Dom_Browser.appendChild(node)(env.parent)();
        return node;
    }))(function (node) {
        return subscribeDyn_(Specular_Dom_Browser.setText(node))(strD);
    });
};
var classes = function (clss) {
    return function (node, v) {
        return Effect.foreachE(clss)(function (cls) {
            return function () {
                return $foreign["_addClass"](node, cls);
            };
        })();
    };
};
var class_ = function (cls) {
    return function (node, v) {
        return $foreign["_addClass"](node, cls);
    };
};
var classWhen = function (enabled) {
    return function (cls) {
        if (enabled) {
            return class_(cls);
        };
        return mempty2;
    };
};
var classUnless = function (enabled) {
    return function (cls) {
        if (enabled) {
            return mempty2;
        };
        return class_(cls);
    };
};
var attrs = function (a) {
    return function (node, v) {
        return Specular_Dom_Browser.setAttributes(node)(a)();
    };
};
var attrsUnless = function (v) {
    if (!v) {
        return attrs;
    };
    if (v) {
        return mempty3;
    };
    throw new Error("Failed pattern match at Specular.Dom.Element (line 183, column 1 - line 183, column 40): " + [ v.constructor.name ]);
};
var attrsWhen = function (v) {
    if (v) {
        return attrs;
    };
    if (!v) {
        return mempty3;
    };
    throw new Error("Failed pattern match at Specular.Dom.Element (line 179, column 1 - line 179, column 38): " + [ v.constructor.name ]);
};
var attr = function (name) {
    return function (value) {
        return attrs(Foreign_Object.singleton(name)(value));
    };
};
var attrUnless = function (v) {
    return function (v1) {
        return function (v2) {
            if (!v) {
                return attr(v1)(v2);
            };
            if (v) {
                return mempty2;
            };
            throw new Error("Failed pattern match at Specular.Dom.Element (line 175, column 1 - line 175, column 55): " + [ v.constructor.name, v1.constructor.name, v2.constructor.name ]);
        };
    };
};
var attrWhen = function (v) {
    return function (v1) {
        return function (v2) {
            if (v) {
                return attr(v1)(v2);
            };
            if (!v) {
                return mempty2;
            };
            throw new Error("Failed pattern match at Specular.Dom.Element (line 171, column 1 - line 171, column 53): " + [ v.constructor.name, v1.constructor.name, v2.constructor.name ]);
        };
    };
};
var _subscribeDyn = function (cleanups, dyn, handler) {
    var unsub = Specular_FRP_Base["_subscribeEvent"](Effect_Uncurried.runEffectFn1(handler), Specular_FRP_Base.changed(dyn));
    Specular_Internal_Effect.pushDelayed(cleanups)(unsub)();
    var initialValue = readDynamic(dyn)();
    return handler(initialValue);
};
var attrsD = function (dynAttrs) {
    return function (node, cleanups) {
        var attrsRef = Effect_Ref["new"](Foreign_Object.empty)();
        var resetAttributes = function (newAttrs) {
            var oldAttrs = Effect_Ref.read(attrsRef)();
            Effect_Ref.write(newAttrs)(attrsRef)();
            var removed = Data_Array.filter(function (k) {
                return !Foreign_Object.member(k)(newAttrs);
            })(Foreign_Object.keys(oldAttrs));
            var changed = Foreign_Object.filterWithKey(function (k) {
                return function (v) {
                    return notEq(Foreign_Object.lookup(k)(oldAttrs))(new Data_Maybe.Just(v));
                };
            })(newAttrs);
            Specular_Dom_Browser.removeAttributes(node)(removed)();
            return Specular_Dom_Browser.setAttributes(node)(changed)();
        };
        return _subscribeDyn(cleanups, dynAttrs, resetAttributes);
    };
};
var attrD = function (name) {
    return function (valD) {
        return attrsD(mapFlipped(valD)(function (v) {
            return Foreign_Object.singleton(name)(v);
        }));
    };
};
var attrUnlessD = function (conditionD) {
    return function (name) {
        return function (value) {
            return attrsD(mapFlipped(conditionD)(function (v) {
                if (v) {
                    return mempty1;
                };
                return Foreign_Object.singleton(name)(value);
            }));
        };
    };
};
var attrWhenD = function (conditionD) {
    return function (name) {
        return function (value) {
            return attrsD(mapFlipped(conditionD)(function (v) {
                if (v) {
                    return Foreign_Object.singleton(name)(value);
                };
                return mempty1;
            }));
        };
    };
};
var attrsUnlessD = function (conditionD) {
    return function (attrs$prime) {
        return attrsD(mapFlipped(conditionD)(function (v) {
            if (v) {
                return mempty1;
            };
            return attrs$prime;
        }));
    };
};
var attrsWhenD = function (conditionD) {
    return function (attrs$prime) {
        return attrsD(mapFlipped(conditionD)(function (v) {
            if (v) {
                return attrs$prime;
            };
            return mempty1;
        }));
    };
};
var classesD = function (clssD) {
    return function (node, cleanups) {
        var updateClasses = $foreign["_initClasses"](node);
        return _subscribeDyn(cleanups, clssD, updateClasses);
    };
};
var classUnlessD = function (enabled) {
    return function (cls) {
        return classesD(mapFlipped(enabled)(function (v) {
            if (v) {
                return [  ];
            };
            return [ cls ];
        }));
    };
};
var classWhenD = function (enabled) {
    return function (cls) {
        return classesD(mapFlipped(enabled)(function (v) {
            if (v) {
                return [ cls ];
            };
            return [  ];
        }));
    };
};
var propertyD = function (property) {
    return function (dyn) {
        return function (node, cleanups) {
            return _subscribeDyn(cleanups, dyn, function (v) {
                return $foreign.setProperty(node, property, v);
            });
        };
    };
};
var checkedD = /* #__PURE__ */ propertyD("checked");
var bindChecked = function (v) {
    return append1(checkedD(v.value0))(on("change")(withTargetChecked(function ($79) {
        return v.value1(Data_Function["const"]($79));
    })));
};
var indeterminateD = /* #__PURE__ */ propertyD("indeterminate");
var valueD = /* #__PURE__ */ propertyD("value");
var bindValueOnChange = function (v) {
    return append1(valueD(v.value0))(on("change")(withTargetValue(function ($80) {
        return v.value1(Data_Function["const"]($80));
    })));
};
var bindValueOnInput = function (v) {
    return append1(valueD(v.value0))(on("input")(withTargetValue(function ($81) {
        return v.value1(Data_Function["const"]($81));
    })));
};
export {
    rawHtml,
    el$prime,
    el,
    el_,
    elNS$prime,
    Prop,
    text,
    dynText,
    attr,
    attrD,
    attrWhen,
    attrUnless,
    attrWhenD,
    attrUnlessD,
    attrs,
    attrsD,
    attrsWhen,
    attrsUnless,
    attrsWhenD,
    attrsUnlessD,
    on,
    onClick,
    onClick_,
    preventDefault,
    stopPropagation,
    valueD,
    bindValueOnChange,
    bindValueOnInput,
    checkedD,
    bindChecked,
    indeterminateD,
    class_,
    classes,
    classesD,
    classWhenD,
    classUnlessD,
    classWhen,
    classUnless,
    semigroupProp,
    monoidProp
};
